// extracted by mini-css-extract-plugin
export default {"layout":"Mz8GyOPwYmWTDq5bXzYF","back":"ahWmz9JlIeb1oLhGXpSQ","content":"a4yGtRckBmESWcxJiRZ4"};